import React, {Component} from 'react';
import NavBar from './components/navBar/index.js';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {fetch_user_details} from './components/loginModal/actions';
import { getAccessToken } from "./utils/auth";
import {Loader} from "./views/Wizard";
import {toastr} from "react-redux-toastr";
import TagManager from 'react-gtm-module'

// class Gtm {
//   tagManager: { gtmId: any; dataLayer: {} }
//   constructor(gtmID, dataLayer = {}) {
//     this.tagManager = {
//       gtmId: gtmID,
//       dataLayer: dataLayer
//     }
//   }
// 
//   trackPageView() {
//     TagManager.initialize(this.tagManager)
//   }
// 
//   setDataLayer(key, value) {
//     this.tagManager.dataLayer[key] = value
//   }
// }


class App extends Component {

    constructor(props) {

        if (window.localStorage.getItem('last_url')) {
            const old_url = window.localStorage.getItem('last_url');
            window.localStorage.removeItem('last_url');
            window.location.href = old_url;
        }

        super(props);
        this.state = {
            tokenCache: null,
            isValidating: false,
            gtm_initialized: false,
            gtm_user_id: null
        };
    }

    initialize_gtm = () => {
        this.set_state({ gtm_initialized: true });
        let user = this.props.user ? this.props.user.email : '';
        if (this.state.gtm_user_id != user) {
            TagManager.initialize({
                gtmId: global.config.gtm_id,
                dataLayer: user ? user : {}
            })
            this.set_state({ gtm_user_id: user });
        }
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.isValidating && !this.state.gtm_initialized) {
            this.initialize_gtm();
        }
        if (this.props.user !== prevProps.user) {
            let accessTkn = getAccessToken();
            this.unsaved_design_management()
            .then(() => {
                this.setState({tokenCache: accessTkn, isValidating: false});
            })
            .catch(() => toastr.error("Something went wrong :/"));
            this.initialize_gtm();
        }

    }

    componentDidMount() {
        this.setState({isValidating: true}, () => {
            this.props.fetch_user_details();
        });
        window.setInterval(this.validateAuth, 2500);
    }

    validateAuth = async () => {
        if (!this.state.isValidating) {
            this.setState({isValidating: true}, async () => {
                let accessToken = await getAccessToken()
                if (accessToken !== this.state.tokenCache) {
                    this.props.fetch_user_details();
                } else
                    this.setState({isValidating: false})
            })
        }
    };

    unsaved_design_management = async () => {
        if (window.localStorage.getItem('unsaved_design_id') && this.props.user) {
            var design_id = window.localStorage.getItem('unsaved_design_id');
            window.localStorage.removeItem('unsaved_design_id');
            var url = global.config.server_path + 'saved_design/claim';
            var design_resp = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify({design_id})
            });
            await design_resp.json();
        }
        return 1;
    };

    render() {
        return (
            <React.Fragment>
                <Loader style={{width:'30%',height: '30%',position:'absolute',left:'35%',top:'35%'}} show_loader={this.props.user === -1}/>

                {(this.props.user !== -1)?(
                    <div style={{'fontFamily': 'Montserrat'}}>
                        <NavBar/>
                        <div className="main_container">
                            {this.props.children}
                        </div>
                    </div>
                ):''}
            </React.Fragment>
        ); 
    }
}

const mapStateToProps = function (state) {
    return {
        user: state.user,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetch_user_details: () => dispatch(fetch_user_details())
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));